import { phone } from "phone"

// format a phone number for display
// if it's a US phone number, it will be formatted as (123) 456-7890
// otherwise we'll leave it alone
export const formatPhoneNumberDisplay = (phoneNumber?: string | null) => {
  if (!phoneNumber) return phoneNumber
  const cleaned = phoneNumber.replace(/\D/g, "")

  if (cleaned.length === 11 && cleaned[0] === "1") {
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`
  }

  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }

  return phoneNumber
}

/**
 * Do our best to turn something like "1 (123) 456-7890" into "+1234567890"
 */
export const normalizePhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return ""

  // try standard formatting first
  const parsed = phone(phoneNumber)
  if (parsed.isValid) {
    return parsed.phoneNumber.replace(/\s/g, "")
  }

  // if it's a US/CA number, we'll try to normalize it
  const cleaned = phoneNumber.replace(/\D/g, "")
  if (cleaned.length === 11 && cleaned[0] === "1") {
    return `+${cleaned.slice(1)}`
  }
  if (cleaned.length === 10) {
    return `+1${cleaned}`
  }

  // give up
  console.warn(`Unable to normalize phone number: ${phoneNumber}`)
  return phoneNumber
}

/**
 * Check if we can/should call/text this number.
 * Specifically, toll-free numbers should not be texted and they can be shared by multiple people.
 */
export const isUseablePhoneNumber = (phoneNumber: string) => {
  const normalized = normalizePhoneNumber(phoneNumber)

  if (normalized && normalized.match(/^(\+1)?8(00|88|77|66|55|44|33)/)) {
    console.warn(`Toll-free number: ${phoneNumber}. Not useable.`)
    return false
  }

  return true
}
